import api from "./api";
import API_URLS from "../../constants/api-urls";

export default class FermentationApi {
  createFermentationApi(fermentationReq) {
    return api.post(API_URLS.URL.fermentation, fermentationReq);
  }

  getFermentationDetailsById(fermentationId) {
    const getFermentationDetailsById =
      API_URLS.URL.getFarmentationDetailsById.replace(
        ":fermentation_id",
        fermentationId,
      );
    return api.get(getFermentationDetailsById);
  }

  getFermentationApi(fermentationReq) {
    return api.post(API_URLS.URL.getFermentation, fermentationReq);
  }

  updateFermentationApi(fermentationId, fermentationReq) {
    const updateFarmentation = API_URLS.URL.updateFarmentation.replace(
      ":fermentation_id",
      fermentationId,
    );
    return api.put(updateFarmentation, fermentationReq);
  }

  createChemistryLogs(chemistryLogsReq) {
    return api.post(API_URLS.URL.chemistrylogs, chemistryLogsReq);
  }

  getChemistryLogsList(chemistryLogsReq) {
    return api.post(API_URLS.URL.getChemistryLogsList, chemistryLogsReq);
  }

  updateChemistryLogs(chemistryLogsId, chemistryLogsReq) {
    const updateChemistryLogs = API_URLS.URL.updateChemistryLogs.replace(
      ":chemistry_logs_id",
      chemistryLogsId,
    );
    return api.put(updateChemistryLogs, chemistryLogsReq);
  }

  deleteChemistryLogs(chemistryLogsId) {
    const updateChemistryLogs = API_URLS.URL.updateChemistryLogs.replace(
      ":chemistry_logs_id",
      chemistryLogsId,
    );
    return api.delete(updateChemistryLogs);
  }

  getTankList(tankLogsReq) {
    return api.post(API_URLS.URL.getTankList, tankLogsReq);
  }

  getTankDetailsById(itemId) {
    const getTankDetailsById = API_URLS.URL.getTankDetailsById.replace(
      ":item_id",
      itemId,
    );
    return api.get(getTankDetailsById);
  }
}
